module.exports = __webpack_public_path__ + "img/front_rise.1ea39b12.png";